//export-to-web-kess.component

import { Component, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageInsitutionManagementService } from '../../ph-bhp-feature-package-insitution-management.service';
import { PHBHPFeaturePackageConfigurationService } from 'src/app/configure/ph-bhp-feature-package-configuration.service';
import { DatePipe } from '@angular/common';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PHBHPFeaturePackageChcService } from 'src/app/chc/ph-bhp-feature-package-chc.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from 'ph-bhp-localization';
import { Router } from '@angular/router';

import { Subscription, forkJoin } from 'rxjs';


@Component({
  selector: 'app-export-to-web-kess',
  templateUrl: './export-to-web-kess.component.html',
  styleUrls: ['./export-to-web-kess.component.css']
})
export class ExportToWebKessComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  checkRunningInterval: any;
  checkStatusIntegrations: any;
  formValueSubscription: Subscription;
  institutionId: any;
  institutionData: any;
  exportWebKessForm: UntypedFormGroup;
  modalRef1: BsModalRef;
  modalRef4: BsModalRef;
  wardList: any;
  departmentList: any;
  uploadConsumption = false;
  uploadObservation = false;
  webKessEnabledDetails: any;
  submittedValue: any;
  disableExport: boolean = false;
  isPeriodDeletion: boolean = false;
  isImportRunning: boolean = false;
  opencancelmodal: boolean = true;
  maxStartDate: Date = new Date();
  maxEndDate: Date = new Date();
  endDate: Date = new Date();
  deleteButtonVisible: boolean = false;
  notWebKessStationExists: boolean = false;
  pageRealoded: boolean = true;
  lastImportType: string = "";
  currentYear;
  previousYear;
  yearSelected;
  choosenDepartmentName = '';
  allYears: any[];
  translationKeys: typeof TranslationKeys = TranslationKeys;

  periodsList: any[] = [];
  availablePeriods: any[] = [];
  langChoosen: string;
  choosenPeriod: any = {};
  consumptionSended: boolean = false;

  dateFormat = {
    'en': 'dd/MM/yyyy',
    'de': 'dd.MM.yyyy',
    'fr': 'dd/MM/yyyy',
    'cs': 'dd/MM/yyyy',
    'sk': 'dd/MM/yyyy',
    'es': 'dd/MM/yyyy',
    'nl': 'dd/MM/yyyy',
    'hu': 'dd/MM/yyyy',
    'pt': 'dd/MM/yyyy'
  }

  today: Date;
  selectedWardName: string = '';
  choosenPeriodName: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    public config: AppConfig,
    private service: PHBHPFeaturePackageInsitutionManagementService,
    private configService: PHBHPFeaturePackageConfigurationService,
    private chcIntegrationService: PHBHPFeaturePackageChcService,
    private datePipe: DatePipe,
    public translate: TranslateService,
    public layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    private router: Router
  ) {
    var date = new Date();
    this.today = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
    this.langChoosen = 'en-GB';
  }

  getLastAvailableYears() {
    let availableYears = [];
    for (let i = 1; i <= 11; i++) {
      availableYears.push(this.currentYear - i);
    }
    return availableYears;
  }

  ngOnInit() {
    this.layoutService
    this.currentYear = new Date().getFullYear();
    this.yearSelected = this.currentYear;
    this.allYears = this.getLastAvailableYears();
    this.institutionId = this.activatedRoute.snapshot.parent.params.id;;
    this.initData();
    this.subscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.initData();
    });
    this.exportWebKessForm = new UntypedFormGroup({
      wardName: new UntypedFormControl('', Validators.compose([Validators.required])),
      wardID: new UntypedFormControl('', Validators.compose([Validators.required])),
      departmentName: new UntypedFormControl('', Validators.compose([Validators.required])),
      period: new UntypedFormControl({}, Validators.compose([Validators.required])),
      startDate: new UntypedFormControl(''),
      endDate: new UntypedFormControl(''),
      year: new UntypedFormControl('')
    });
    this.formValueSubscription = this.exportWebKessForm.valueChanges.subscribe(value => {
      if (this.submittedValue) {
        if (this.submittedValue.wardID == this.exportWebKessForm.value.wardID &&
          this.submittedValue.departmentID == this.exportWebKessForm.value.departmentName &&
          this.datePipe.transform(new Date(this.submittedValue.startDate), 'dd/MM/yyyy') == this.datePipe.transform(this.exportWebKessForm.value.startDate, 'dd/MM/yyyy') &&
          this.datePipe.transform(new Date(this.submittedValue.endDate), 'dd/MM/yyyy') == this.datePipe.transform(this.exportWebKessForm.value.endDate, 'dd/MM/yyyy')
        ) {
          this.disableExport = true;
        } else {
          this.disableExport = false;
        }
      }
    });

    this.checkRunningInterval = setInterval(() => {
      this.chcIntegrationService.getwebKessIntegerationLogByInstitutionId(this.institutionId).subscribe((webKessIntegrationsRes: any) => {
        if (!webKessIntegrationsRes || webKessIntegrationsRes.length == 0) return;
        
        this.isImportRunning = webKessIntegrationsRes.some(
          integeration => {
              var currentDate: any = new Date(new Date().toISOString());
              var integrationDate: any = new Date(integeration.chcImportDateTime + 'Z');
              var hoursBetweenDates = (Math.abs((currentDate - integrationDate) / 36e5));
              if ((integeration.chcImportStatus == 'IMPORT_RUNNING' || integeration.chcImportStatus == null) && (hoursBetweenDates < 1)) {
                this.lastImportType = integeration.chcImportType;
                console.log(this.lastImportType);
                return true;
              } else 
                return false;
          }
        );

        //After the import we refresh the page in order to fix updating problems.
        if (this.isImportRunning) {
          this.pageRealoded = false;
        } else if (!this.pageRealoded && this.lastImportType != "Observation Intervals") {
          //we do not refresh when chcImportType = Observation Intervals, because the transaction is not completed.
          console.log(this.lastImportType);
          this.reloadCurrentRoute();
          this.pageRealoded = true;
        }

      });
    }, 5000);

    //With the improved flow, this periodic check is no longer necessary.

    //this.checkStatusIntegrations = setInterval(() => {
    //this.chcIntegrationService.checkPendingIntegrations(this.institutionId).subscribe((updatedIntegrations: any) => {});
    //}, 60*1000);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    clearInterval(this.checkRunningInterval);
    //clearInterval(this.checkStatusIntegrations);
    if (this.formValueSubscription) { this.formValueSubscription.unsubscribe(); }
  }

  initData() {
    const institutionDetails = this.service.GetInstitutionDetails(this.institutionId);
    const webKessStations = this.configService.getInsWebKessStations(this.institutionId);
    const webKessInstitutionDetail = this.configService.getwebKessInstitutionDetails(this.institutionId);
    const webKessPeriods = this.configService.getwebKessPeriodsDetail(this.institutionId);
    const webKessIntegrations = this.chcIntegrationService.getwebKessIntegerationLogByInstitutionId(this.institutionId);
    this.layoutService.showLoader = true;

    forkJoin([institutionDetails, webKessStations, webKessInstitutionDetail, webKessPeriods, webKessIntegrations]).subscribe(([institutionDetailsRes, webKessStationsRes, webKessInstitutionDetailRes, webKessPeriodsRes, webKessIntegrationsRes]) => {
      this.layoutService.showLoader = false;
      this.institutionData = institutionDetailsRes;
      // 3 219 15
      if ((this.config.userData.roleName.roleId !== 5) &&
        (this.institutionData.institution.institution.activateWebKess) && ([3, 219, 15].includes(this.institutionData.institution.institution.countryID))) {
        if (webKessStationsRes) {
          this.wardList = webKessStationsRes;
          this.wardList = this.wardList.filter(ward => ward.iswebKessStation); //HHP1041 - show only webkess stations
          this.webKessEnabledDetails = webKessInstitutionDetailRes;
          if (this.wardList.length > 0) {
            const deptList = this.wardList.map(el => ({ departmentID: el.departmentID, departmentName: el.departmentName }));
            this.departmentList = Object.values(deptList.reduce((acc, cur) => Object.assign(acc, { [cur.departmentID]: cur }), {}));
            this.getDepartment(this.wardList[0]);
          }

          this.showHideRadioButtonGroup(webKessInstitutionDetailRes.activateObservation, webKessInstitutionDetailRes.activateConsumption);
        }

        this.periodsList = webKessPeriodsRes;
        for (let i = 0; i < this.periodsList.length; i++) {
          var period = this.periodsList[i];
          var associatedWard = this.wardList.find(ward => (period.station == ward.webkessWardName));
          if (associatedWard) {
            this.periodsList[i].wardID = associatedWard.wardID;
          }
        }

        // Ensure period dropdown is populated for the default/preselected ward on initial load.
        if (this.wardList && this.wardList.length > 0) {
          this.getDepartment(this.wardList[0]);
          if (this.uploadObservation && this.availablePeriods && this.availablePeriods.length > 0) {
            this.changePeriod(this.availablePeriods[0]);
          }
        }

        if (webKessIntegrationsRes && webKessIntegrationsRes.length > 0) {
          this.isImportRunning = webKessIntegrationsRes.some(
            integeration => {
              var currentDate: any = new Date(new Date().toISOString());
              var integrationDate: any = new Date(integeration.chcImportDateTime + 'Z');
              var hoursBetweenDates = (Math.abs((currentDate - integrationDate) / 36e5));
              return (integeration.chcImportStatus == 'IMPORT_RUNNING' || integeration.chcImportStatus == null) && (hoursBetweenDates < 1)
            }
          );
        }

        this.layoutService.showLoader = false;
      }

    })
  }

  changePeriod(period) {
    this.choosenPeriod = period;
    this.exportWebKessForm.patchValue({
      period: period
    });
    if (period.name == 'newperiod') {
      this.choosenPeriodName = this.translate.instant(this.translationKeys.Configure.NewPeriod);
    } else {
      let startDate = new Date(period.startDate).toLocaleDateString(this.langChoosen, this.dateFormat[this.langChoosen]);
      let endDate = new Date(period.endDate).toLocaleDateString(this.langChoosen, this.dateFormat[this.langChoosen]);
      let statusText = period.status == 'IMPORT_RUNNING' ? (this.isPeriodDeletion ? 'Deletion in Progress' : this.translate.instant(this.translationKeys.Webkess.ImportRunning)) : '';
      this.choosenPeriodName = `${startDate} - ${endDate} ${statusText}`;
    }
    this.deleteButtonVisible = false;
    if (!!this.choosenPeriod && Object.keys(this.choosenPeriod).includes('intervalId')) {
      this.deleteButtonVisible = true;
    }
  }


  getDepartment(ward) {
    this.choosenPeriodName = '';
    this.choosenPeriod = {};
    this.exportWebKessForm.patchValue({ period: ' ' });
    if (ward && ward.wardName && ward.departmentID) {
      this.selectedWardName = ward.wardName;
      this.exportWebKessForm.patchValue({
        wardID: ward.wardID,
        wardName: ward.wardName
      });
      const department = this.departmentList.find(res => res.departmentID === ward.departmentID)
      this.exportWebKessForm.patchValue({ departmentName: department.departmentID });
      this.choosenDepartmentName = this.translate.instant(department.departmentName);
      this.availablePeriods = this.periodsList.filter(period => period.wardID == ward.wardID);

      // Show a default value in the period input after changing ward
      if (this.uploadObservation && this.availablePeriods && this.availablePeriods.length > 0) {
        this.changePeriod(this.availablePeriods[0]);
      }
    } else {
      this.selectedWardName = '';
    }
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  onYearChange(year) {
    this.yearSelected = year;
    this.exportWebKessForm.patchValue({ year: year });
  }


  showHideRadioButtonGroup(observation, consumption) {
    const data = {
      target: {
        value: 'on'
      }
    };
    if (observation && consumption || observation) {
      this.ObservationChange(data);
    } else if (consumption && !observation) {
      this.ConsumptionChange(data);
    }
  }

  ConsumptionChange(evt) {
    if (evt.target.value === 'on') {
      this.uploadConsumption = true;
      this.uploadObservation = false;
    }
    this.clearWardDepartment();
    this.exportWebKessForm.get('startDate').clearValidators();
    this.exportWebKessForm.get('endDate').clearValidators();
    this.exportWebKessForm.get('year').setValidators(Validators.required);
    this.updateFormValidation();
    this.getDepartment(this.wardList[0]);
    this.formValueCheck();
  }

  ObservationChange(evt) {
    if (evt.target.value === 'on') {
      this.uploadObservation = true;
      this.uploadConsumption = false;
    }
    this.clearWardDepartment();
    this.exportWebKessForm.get('startDate').setValidators(Validators.required);
    this.exportWebKessForm.get('endDate').setValidators(Validators.required);
    this.exportWebKessForm.get('year').clearValidators();
    this.updateFormValidation();
    this.getDepartment(this.wardList[0]);
    this.formValueCheck();
  }

  updateFormValidation() {
    this.exportWebKessForm.get('startDate').updateValueAndValidity();
    this.exportWebKessForm.get('endDate').updateValueAndValidity();
    this.exportWebKessForm.get('year').updateValueAndValidity();
  }

  clearWardDepartment() {
    this.exportWebKessForm.reset();
    this.exportWebKessForm.clearValidators();
    this.exportWebKessForm.updateValueAndValidity();
    this.getDepartment(this.wardList[0]);
  }

  formValueCheck() {
    if (this.submittedValue) {
      if (this.submittedValue.type === 'ASH') {
        this.submittedValue['uploadObservation'] = true;
      } else {
        this.submittedValue['uploadObservation'] = false;
      }
      if (this.submittedValue.type === 'HandKiss') {
        this.submittedValue['uploadConsumption'] = true;
      } else {
        this.submittedValue['uploadConsumption'] = false;
      }

      this.disableExport = true;

    }
  }

  deletionClick() {
    this.modalRef4.hide();
    this.isPeriodDeletion = true;
    this.exportSubmit();
  }

  openCancelModal(cancelmodal: TemplateRef<any>, deletePeriodConfirmationModal: TemplateRef<any>) {
    if (this.opencancelmodal == false) {
      this.modalRef1 = this.modalService.show(cancelmodal, Object.assign({}, { class: 'w-420' })
      )
    }
    else {
      this.openDeletionModal(deletePeriodConfirmationModal);
    }
  }


  openDeletionModal(deletePeriodConfirmationModal: TemplateRef<any>) {
    this.modalRef4 = this.modalService.show(deletePeriodConfirmationModal, Object.assign({}, { class: 'w-420' })
    )
  }

  exportSubmit() {
    if (this.uploadObservation) {
      if (this.choosenPeriod.status == 'IMPORT_RUNNING') {
        this.layoutService.showError(this.translate.instant(this.translationKeys.Webkess.UploadRunning));
        return;
      }

      this.layoutService.showLoader = true;

      if (this.exportWebKessForm.value.period == ' ' || this.exportWebKessForm.value.period == null) {
        this.exportWebKessForm.patchValue({ period: null });
      } else if (this.choosenPeriod.name == 'newperiod') {
        const start = this.exportWebKessForm.value.startDate;
        const end = this.exportWebKessForm.value.endDate;
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        let valid = true;
        let overlapedPeriod;
        for (var period of this.availablePeriods) {
          const periodStart = new Date(period.startDate);
          const periodEnd = new Date(period.endDate);
          periodStart.setHours(0, 0, 0, 0);
          periodEnd.setHours(0, 0, 0, 0);
          if ((start >= periodStart && start <= periodEnd) || (end >= periodStart && end <= periodEnd) || (start <= periodStart && end >= periodEnd)) {
            valid = false;
            overlapedPeriod = period;
            break;
          }
        };
        if (!valid) {
          const datePipe = new DatePipe(this.langChoosen);
          this.layoutService.showError(this.translate.instant(this.translationKeys.Webkess.OverlappedPeriod) + ' ' + datePipe.transform(overlapedPeriod.startDate, this.dateFormat[this.langChoosen]) + '-' + datePipe.transform(overlapedPeriod.endDate, this.dateFormat[this.langChoosen]));
          this.layoutService.showLoader = false;
          return false;
        }
      } else {
        this.exportWebKessForm.patchValue({ 'startDate': new Date(this.exportWebKessForm.value.period.startDate) });
        this.exportWebKessForm.patchValue({ 'endDate': new Date(this.exportWebKessForm.value.period.endDate) });
      }
    } else {
      this.layoutService.showLoader = true;
    }

    if (this.exportWebKessForm.invalid) {
      this.layoutService.showLoader = false;
      return false;
    } else {
      if (this.uploadObservation) {
        const stDateCheck = new Date(this.exportWebKessForm.value.startDate.getFullYear(),
          this.exportWebKessForm.value.startDate.getMonth(), this.exportWebKessForm.value.startDate.getDate());
        const endDateCheck = new Date(this.exportWebKessForm.value.endDate.getFullYear(),
          this.exportWebKessForm.value.endDate.getMonth(), this.exportWebKessForm.value.endDate.getDate());
        if (stDateCheck.valueOf() > endDateCheck.valueOf()) {
          this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.ExportEndDate));
          this.layoutService.showLoader = false;
          return false;
        }
      }

      var ward = this.wardList.find(el => el.wardID === this.exportWebKessForm.value.wardID);
      const postValue: any = {
        'institutionID': this.institutionId,
        'wardID': this.exportWebKessForm.value.wardID,
        'departmentID': this.exportWebKessForm.value.departmentName,
        'startDate': this.exportWebKessForm.value.startDate,
        'endDate': this.exportWebKessForm.value.endDate,
        'station': ward.webkessWardName,
        'webkessname': ward.webkessWardName,
        'userID': this.config.userData.userId,
        'roleID': this.config.userData.roleName.roleId,
        'intervalId': this.choosenPeriod.intervalId
      };

      let stDt = new Date();
      let endDt = new Date();

      if (this.uploadConsumption) {
        stDt = new Date(this.yearSelected, 0, 1);
        endDt = new Date(this.yearSelected, 11, 31, 23, 59, 59);
      } else {
        stDt = new Date(postValue.startDate.getFullYear(), postValue.startDate.getMonth(), postValue.startDate.getDate());
        endDt = new Date(postValue.endDate.getFullYear(), postValue.endDate.getMonth(), postValue.endDate.getDate(), 23, 59, 59);
        const Difference_In_Time = endDt.getTime() - stDt.getTime();
        const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        if (Difference_In_Days > 42.5) { //Added 0.5 due to daylight saving time
          this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.PeriodTooLong));
          this.layoutService.showLoader = false;
          return false;
        }
      }

      postValue.startDate = this.layoutService.convertUTCDateToLocalDate(stDt);// new Date(stDt.getTime() - (new Date(stDt).getTimezoneOffset()*60000)).toUTCString()
      postValue.endDate = this.layoutService.convertUTCDateToLocalDate(endDt); //new Date(endDt.getTime() - (new Date(endDt).getTimezoneOffset()*60000)).toUTCString()


      if (this.uploadObservation) {
        postValue.type = 'ASH';
        this.exportPostCall(postValue);
      } else if (this.uploadConsumption) {
        postValue.type = 'HandKiss';
        this.exportPostCall(postValue);
      } else {
        if (this.webKessEnabledDetails.activateObservation) {
          this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.SelectConsumption));
        } else {
          this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.ChooseConsumption));
        }
        this.layoutService.showLoader = false;
        return false;
      }
    }
  }

  exportPostCall(postValue) {
    this.submittedValue = postValue;
    setTimeout(() => {
      this.layoutService.showLoader = false;
    }, 6000);
    if (!this.isPeriodDeletion)
      this.layoutService.showSuccess(this.layoutService.translateText(this.translationKeys.Webkess.ExportInitiated));
    else
      this.layoutService.showSuccess(this.layoutService.translateText(this.translationKeys.Webkess.DeletePeriodInitiated));

    if (this.choosenPeriod.name == 'newperiod') {
      const newPeriod = {
        departmentID: postValue.departmentID,
        station: postValue.webkessname || postValue.station,
        startDate: this.exportWebKessForm.value.startDate,
        endDate: this.exportWebKessForm.value.endDate,
        status: 'IMPORT_RUNNING'
      };
      this.availablePeriods.push(newPeriod);
      this.choosenPeriod = newPeriod;
      this.exportWebKessForm.patchValue({ period: newPeriod });
    } else {
      this.choosenPeriod.status = 'IMPORT_RUNNING';
    }

    this.consumptionSended = true;
    this.disableExport = true;
    this.isImportRunning = true;

    if (!this.isPeriodDeletion) {
      this.configService.webKessIntervalsObservations(postValue).subscribe((res: any) => {
        if (!res.data) {
          if (this.uploadObservation) {
            if (this.choosenPeriod.name == 'newperiod') {
              this.availablePeriods.pop();
            }
            setTimeout(() => {
              this.layoutService.showError(this.translate.instant(this.translationKeys.Webkess.NoObservations));
              this.consumptionSended = false;
              this.exportWebKessForm.patchValue({ period: {} });
            }, 6000);
            this.choosenPeriod.status = '';
            this.consumptionSended = false;
            this.choosenPeriod = {};

          } else {
            setTimeout(() => {
              this.layoutService.showError(this.translate.instant(this.translationKeys.Webkess.NoConsumptions));
              this.disableExport = false;
              this.consumptionSended = false;
            }, 6000);
          }
          
        }else{
          
          const numbers = res.status.split('/');
          const sendedObs = parseInt(numbers[0]);
          const multiselectObs = parseInt(numbers[1]);
          const totalObs = sendedObs + multiselectObs;

          if (multiselectObs == 0)
            this.layoutService.showSuccess(
              this.translate.instant(this.translationKeys.Webkess.UploadFinished) 
              + ": " + sendedObs + " " 
              + this.translate.instant(this.translationKeys.Webkess.UploadFinishedSentToWebkess));
          else
            this.layoutService.showSuccess(
              this.translate.instant(this.translationKeys.Webkess.UploadFinished) 
              + ": " + sendedObs + " / " + totalObs + " "
              + this.translate.instant(this.translationKeys.Webkess.UploadFinishedSentToWebkess));
          
          this.availablePeriods.forEach(period => period.status = '');
          this.service.webKessUploadResult.next();
          this.disableExport = false;
          this.consumptionSended = false;
        }
      });
    }
    else {
      this.configService.webKessIntervalsDeletion(postValue).subscribe((res: any) => {
        if (!res.data) {
          setTimeout(() => {
            this.layoutService.showError(this.translate.instant(this.translationKeys.Webkess.DeletionPeriod));
            this.isPeriodDeletion = false;
            this.disableExport = false;
            this.consumptionSended = false;
          }, 6000);

        }
        else {
          this.layoutService.showSuccess(this.translate.instant(this.translationKeys.Webkess.DeletePeriodCompleted));
          this.availablePeriods.forEach(period => period.status = '');
          this.service.webKessUploadResult.next();
          this.disableExport = false;
          this.consumptionSended = false;
          let position = this.availablePeriods.findIndex(period => period.intervalId == this.choosenPeriod.intervalId);
          this.availablePeriods.splice(position, 1);
          this.isPeriodDeletion = false;
        }
      });
    }
  }
}
